var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-settings" },
    [
      _c("Heading", {
        class: "mb-4",
        attrs: {
          title: _vm.$t("account_container_my_account"),
          "just-title": true,
          routeName: "vignette",
          showLogout: true,
          alignment: "text-center",
        },
      }),
      _c("div", { staticClass: "container container-small" }, [
        _c("div", { ref: "tabs", staticClass: "tabs" }, [
          _c(
            "div",
            { staticClass: "tabs-wrapper d-flex remove-a" },
            [
              _c(
                "router-link",
                {
                  staticClass: "checkout-tab-button text-center",
                  attrs: { to: { name: "my-cars" } },
                },
                [
                  _c("i", { staticClass: "vehicles-icon" }),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("account_container_vehicles"))),
                  ]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "checkout-tab-button text-center",
                  attrs: { to: { name: "my-orders" } },
                },
                [
                  _c("i", { staticClass: "orders-icon" }),
                  _c("p", [_vm._v(_vm._s(_vm.$t("account_container_orders")))]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "checkout-tab-button text-center",
                  attrs: { to: { name: "profiles" } },
                },
                [
                  _c("i", { staticClass: "profiles-icon" }),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("account_container_profiles"))),
                  ]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "checkout-tab-button text-center",
                  attrs: { to: { name: "cards" } },
                },
                [
                  _c("i", { staticClass: "fal fa-credit-card" }),
                  _c("p", [_vm._v(_vm._s(_vm.$t("account_container_cards")))]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "checkout-tab-button text-center",
                  attrs: { to: { name: "account-data" } },
                },
                [
                  _c("i", { staticClass: "account-icon" }),
                  _c("p", [_vm._v(_vm._s(_vm.$t("account_container_info")))]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }